export default "__VITE_ASSET__UObaiQq5__"